import { useEffect, useRef, useState } from "react";

import api from "@helpers/api";

export default function useRanking(groupId) {
    const [loading, setLoading] = useState(true);
    const [data, setData] = useState(null);
    const scrollRef = useRef(null);
    const [canScrollLeft, setCanScrollLeft] = useState(false);
    const [canScrollRight, setCanScrollRight] = useState(false);

    useEffect(() => {
        load();
    }, [groupId]);

    async function load() {
        setLoading(true);
        try {
            const { data } = await api.get(
                `community/group/${groupId}/ranking?page=0&limit=15`
            );
            setData(data);
        } catch (e) {
            console.log(e);
        }
        setLoading(false);
    }

    function updateArrows() {
        const el = scrollRef.current;
        if (!el) return;
        setCanScrollLeft(el.scrollLeft > 4);
        setCanScrollRight(el.scrollLeft + el.clientWidth < el.scrollWidth - 4);
    }

    useEffect(() => {
        if (loading) return;
        const el = scrollRef.current;
        if (!el) return;
        el.scrollLeft = 0;
        updateArrows();
        el.addEventListener("scroll", updateArrows, { passive: true });
        window.addEventListener("resize", updateArrows);
        return () => {
            el.removeEventListener("scroll", updateArrows);
            window.removeEventListener("resize", updateArrows);
        };
    }, [loading, data]);

    function scrollBy(dir) {
        const el = scrollRef.current;
        if (!el) return;
        el.scrollBy({ left: dir * el.clientWidth * 0.8, behavior: "smooth" });
    }

    return {
        loading,
        data,
        scrollRef,
        canScrollLeft,
        canScrollRight,
        scrollBy,
    };
}
